import React, { FormEvent, useEffect, useState } from 'react';
import { GetMeDocument, UpdateMeDocument } from '@nebulr-group/nblocks-react/lib/gql/graphql';
import { useMutation, useQuery } from '@apollo/client';
import { AlertComponent } from '@nebulr-group/nblocks-react/lib/components/shared/AlertComponent';
import { InputComponent } from '@nebulr-group/nblocks-react/lib/components/shared/InputComponent';
import { NblocksButton } from '@nebulr-group/nblocks-react/lib/components/shared/NblocksButton';

const Profile = () => {
  const [errorMsg, setErrorMsg] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const { data, loading } = useQuery(GetMeDocument);
  const [updateMeMutation, updateMeData] =
    useMutation(UpdateMeDocument);

  useEffect(() => {
    if (data && data.getMe) {
      const me = data.getMe;

      if (me.firstName)
        setFirstName(me.firstName);

      if(me.lastName)
        setLastName(me.lastName);
    }
  }, [data]);

  const isLoading = loading || updateMeData.loading;
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (data?.getMe) {
      try {
        await updateMeMutation({
          variables: { user: {firstName, lastName} },
        });
      } catch (error) {
        setErrorMsg(
          "There was an error when updating your workspace. Try again, otherwise contact support."
        );
      }
    }
  };
  
  return (
    <>
      {errorMsg && (
        <div className="max-w-sm w-full mb-6">
          <AlertComponent
            type="danger"
            title="An error occured"
            messages={[errorMsg]}
          />
        </div>
      )}
      <form
        onSubmit={(event) => submit(event)}
        className="space-y-6 max-w-sm w-full"
      >

        <InputComponent
          type="text"
          label="First name"
          placeholder="Enter your first name"
          name="firstName"
          onChange={(event) => setFirstName(event.target.value)}
          value={firstName}
        />
        <InputComponent
          type="text"
          label="Last name"
          placeholder="Enter your last name"
          name="lastName"
          onChange={(event) => setLastName(event.target.value)}
          value={lastName}
        />
        <div>
          <NblocksButton
            submit={true}
            size="md"
            isLoading={isLoading}
            type="primary"
            fullWidth={true}
          >
            Save
          </NblocksButton>
        </div>
      </form>
    </>
  );
}

export { Profile }